import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionDomainExtensionFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals

/**
 * 
 * @export
 * @interface ExpExpressionDomainExtension
 */

export class ExpExpressionDomainExtensionFactory {}
_ExpExpressionDomainExtensionFactory = ExpExpressionDomainExtensionFactory;
_defineProperty(ExpExpressionDomainExtensionFactory, "FromJSON", function (json) {
  return _ExpExpressionDomainExtensionFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionDomainExtensionFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'expressionDomain': json['expressionDomain'],
    'extensionType': json['extensionType'] === null || json['extensionType'] === undefined ? json['extensionType'] : json['extensionType']
  };
});
_defineProperty(ExpExpressionDomainExtensionFactory, "ToJSON", function (value) {
  return _ExpExpressionDomainExtensionFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionDomainExtensionFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'expressionDomain': value.expressionDomain,
    'extensionType': value.extensionType
  };
});
//# sourceMappingURL=ExpExpressionDomainExtension.js.map
